/**
 * Turn a value into plain text for the page. Objects use JSON (not `String(obj)` → `[object Object]`).
 */
export function valueToDisplayString(input: unknown): string {
  if (input == null) return "";
  if (typeof input === "string") return input;
  if (typeof input === "number" || typeof input === "boolean") {
    return String(input);
  }
  if (typeof input === "object") {
    try {
      return JSON.stringify(input);
    } catch {
      return "";
    }
  }
  return String(input);
}

/** Escapes text for HTML. Coerces non-strings (e.g. numeric JSON fields) so `.replace` never throws. */
export function escapeHtml(input: unknown): string {
  const s = valueToDisplayString(input);
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
